import React from 'react';
import styled from 'styled-components';
import iconMap from '../assets/images/icon-map.png';
import Altrud from '../assets/images/altrud.png';
import Barksven from '../assets/images/barksven.png';
import Sigfast from '../assets/images/sigfast.png';

const MapImages = (): JSX.Element => {
  return (
    <MapImagesWrapper>
      <SBLink href={'https://www.systembolaget.se/produkt/sprit/nyurundum-3697202/'} target="_blank">
        <BoxesImage src={Barksven} />
      </SBLink>
      <SBLink href={'https://www.systembolaget.se/produkt/sprit/nyurundum-3697102/'} target="_blank">
        <BoxesImage src={Sigfast} />
      </SBLink>
      <SBLink href={'https://www.systembolaget.se/produkt/ol/nyurundum-3696801/'} target="_blank">
        <BoxesImage src={Altrud} />
      </SBLink>
    </MapImagesWrapper>
  );
};

const MapImagesWrapper = styled.div`
  background-image: url(${iconMap});
  display: grid;
  grid-template-columns: auto;
  grid-gap: 2rem;
  align-items: center;
  justify-content: center;
  padding-top: 3rem;
  padding-bottom: 3rem;

  @media (min-width: 769px) {
    grid-template-columns: repeat(3, auto);
    grid-gap: 5rem;
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
`;

const SBLink = styled.a`
  height: 100%;
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
`;

const BoxesImage = styled.img`
  height: 13rem;
  background-color: white;
  box-shadow: 0px 0px 10px black;
  padding: 2rem;

  @media (min-width: 769px) {
    height: 25rem;
  }
`;

export default MapImages;
